export default "__VITE_ASSET__Y2Umv5EF9VlBEHBZ0D$Ftg__"